module.exports = __webpack_public_path__ + "media/images/logo-black-cc7cf1f3dc311d568c0fd1ba5e511c80.png";